module.exports = __webpack_public_path__ + "assets/1ce1b682755ca9eed9874ff7e166973a.svg";